module.exports = __webpack_public_path__ + "img/owai.164e5e14.png";